import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncManageBooking = Load(
  () =>
    import(
      /* webpackChunkName: "manage-booking" */ './containers/ManageBookingContainer'
    ),
);

export default [
  <NavigationableLayout
    key={'manage-booking'}
    hideFooter
    component={AsyncManageBooking}
    path={`${basePath}/manage-booking/:bookingId`}
    noNavbar={isCordova()}
  />,
];
